import { getDomain } from "../configs/http-config";
import { getOrigin } from "../utils/widgetStorage";

const RECONNECT_DELAY_MS = 3000;
const MAX_RECONNECT_ATTEMPTS = 5;

class FileScanSSEClient {
	source = null;
	reconnectAttempts = 0;
	reconnectTimer = null;
	listeners = new Map();
	connectionParams = null;

	connect({ tenantId, contactId, botId }) {
		this.disconnect();
		this.connectionParams = { tenantId, contactId, botId };

		const origin = getOrigin();
		const params = new URLSearchParams({
			tenantId,
			contactId,
			botId,
			xHost: origin?.hostname || "",
			xPathname: origin?.pathname || "",
		});

		const url = `${getDomain()}/atombot/api/v1/files/sse/status?${params}`;
		this.source = new EventSource(url);

		this.source.addEventListener("file_scan_status", (e) => {
			try {
				const data = JSON.parse(e.data);
				this._notifyListeners(data);
			} catch (err) {
				console.error("FileScanSSEClient: failed to parse event", err);
			}
		});

		this.source.onopen = () => {
			this.reconnectAttempts = 0;
		};

		this.source.onerror = () => {
			this.source?.close();
			this.source = null;
			this._scheduleReconnect();
		};
	}

	disconnect() {
		if (this.reconnectTimer) {
			clearTimeout(this.reconnectTimer);
			this.reconnectTimer = null;
		}
		if (this.source) {
			this.source.close();
			this.source = null;
		}
		this.reconnectAttempts = 0;
		this.connectionParams = null;
	}

	onStatusUpdate(callback) {
		const id = Symbol();
		this.listeners.set(id, callback);
		return () => this.listeners.delete(id);
	}

	_notifyListeners(data) {
		this.listeners.forEach((cb) => {
			try { cb(data); } catch (e) { console.error("FileScanSSEClient listener error", e); }
		});
	}

	_scheduleReconnect() {
		if (this.reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) return;
		this.reconnectAttempts++;
		this.reconnectTimer = setTimeout(() => {
			if (this.connectionParams) {
				this.connect(this.connectionParams);
			}
		}, RECONNECT_DELAY_MS * this.reconnectAttempts);
	}
}

export const fileScanSSEClient = new FileScanSSEClient();
